import React, { useEffect, useState } from "react";
import { Button, Table, Modal } from "antd";
import axios from "axios";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import SearchBox from "../../../components/SearchBox";
import ActivityFilterPage from "./ActivityFilterPage";
import { Api_Url } from "../../../config/config";

const ActivitiesPage = () => {
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [alldata, setALlData] = useState({});

  const navigate = useNavigate();

  const handleFilterLeads = (data) => {
    setFilteredLeads(data);
  };



  const columns = [
    {
      title: "User Name",
      dataIndex: "userName",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Designation Name",
      dataIndex: "designationName",
    },
    {
      title: "Department Name",
      dataIndex: "departmentName",
    },
    {
      title: "Activity Name",
      dataIndex: "name",
    },
    {
      title: "Description",
      dataIndex: "description",
    },
    {
      title: "Activity Date",
      dataIndex: "activityDate",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button
          className="btn-property"
          onClick={() => handleViewClick(record)}
        >
          <i className="fa-solid fa-eye"></i>
        </Button>
      ),
    },
  ];

  // console.log("data", alldata.firstName);

  const handleViewClick = async (record) => {
    console.log(record);

    const urlMap = {
      1: "CollectionVisit",
      2: "AuthorityVisit",
      3: "PropertyVisit",
      4: "BrokerVisit",
      5: "DeskWork",
      6: "Lead",
      7: "FileLogin",
      8: "CollectingIMD",
      9: "OTCClearance",
      10: "EMICollection",
      11: "ChannelPartner",
      12: "MarketingActivity",
      13: "VendorVisit",
      14: "BusinessPd",
      15: "ResidencePd",
      16: "CollectingDocument",
      17: "BankVisit",
      18: "CustomerVisit",
      19: "BTBankVisit",
      20: "LeadGeneration",
      21: "BrandVisibility",
      22: "ActivityToRecruit",
      23: "DutyOn",
      24: "DutyOff",
    };

    const endpoint = urlMap[record.activityId];

    if (endpoint) {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/${endpoint}/${record.tableId}`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        console.log(response.data.data);
          // setALlData(response?.data?.data);
          // setIsModalVisible(true);
        if (endpoint === 'BusinessPd') {
          navigate('/buisness-pd');
        } else {
          setALlData(response?.data?.data);
          setIsModalVisible(true);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log(`No handler for activityId ${record.activityId}`);
    }
  };

  const handleActivityLogFunc = async () => {

    const userId= JSON.parse(sessionStorage.getItem('user'))?.id
    try {
      const response = await axios.get(`${Api_Url}api/v1/ActivityLog/myteam?UserId=${userId}&PageNumber=1&PageSize=100`, {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user")).accessToken
          }`,
        },
      });
      console.log(response.data)
      const data = response.data.data;
      setFilteredLeads(data);
    } catch (error) {
      console.error("Activity Log API Error", error);
    }
  };

  useEffect(() => {
    handleActivityLogFunc();
  }, []);


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Activities</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Activities</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <ActivityFilterPage parentFunctionLeads={handleFilterLeads} />
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                {/* <SearchBox /> */}
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={filteredLeads}
                  rowKey={(record) => record.id}
                  // pagination={{ pageSize: 10 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
  title="Activity Details"
  visible={isModalVisible}
  onCancel={() => setIsModalVisible(false)}
  footer={null}
  className="custom-modal"  // Add custom class for additional styling if needed
>
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="card">
          <div className="card-body d-flex align-items-center">
            {alldata?.selfieUrl && (
              <div className="selfie-container me-3">
                <img
                  src={alldata.selfieUrl}
                  alt="Selfie"
                  style={{ width: "60px", height: "60px", borderRadius: "50%" }}
                />
              </div>
            )}
            <div>
              <h1 className="card-title">
                {alldata?.firstName} {alldata?.lastName} {alldata?.name}
              </h1>
              <p className="card-text mb-1">Branch Name: { alldata?.branchName}
              </p>
              <p className="card-text mb-1">
                {alldata?.mobile ? `Mobile No: ${alldata?.mobile}` : ""}
              </p>
              <p className="card-text mb-1">
                {alldata?.applicationNo ? `Application No: ${alldata?.applicationNo}` : ""}
              </p>
              <p className="card-text mb-1">
                {alldata?.loanNumber ? `Loan No: ${alldata?.loanNumber}` : ""}
              </p>
              <p className="card-text mb-1">
                {alldata?.remark ? `Remark: ${alldata?.remark}` : ""}
              </p>
              <p className="card-text">
                {alldata?.created
                  ? `Created At: ${moment(alldata?.created).format("MMMM Do YYYY, h:mm:ss a")}`
                  : "Creation date not available"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</Modal>
    </>
  );
};

export default ActivitiesPage;